import { render, staticRenderFns } from "./RankingsPublic.vue?vue&type=template&id=79c22929&scoped=true"
import script from "./RankingsPublic.vue?vue&type=script&lang=js"
export * from "./RankingsPublic.vue?vue&type=script&lang=js"
import style0 from "./RankingsPublic.vue?vue&type=style&index=0&id=79c22929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c22929",
  null
  
)

export default component.exports